import React from 'react';
import { AlertTriangle } from 'lucide-react';
export function UrgencyBar() {
  return <div className="fixed top-0 left-0 right-0 bg-brand-coral text-white z-50 shadow-md" data-id="element-163">
      <div className="max-w-4xl mx-auto px-4 py-3 flex items-center justify-center gap-3 text-sm md:text-base font-medium text-center" data-id="element-164">
        <AlertTriangle className="w-5 h-5 flex-shrink-0 animate-pulse" data-id="element-165" />
        <p data-id="element-166">
          <span className="font-bold" data-id="element-167">ATENCIÓN:</span> El precio especial de
          lanzamiento de $6.39 USD finaliza hoy a la medianoche. Quedan pocas
          copias con los 15 bonos incluidos.
        </p>
      </div>
    </div>;
}